export function formatList(list: string[], spacer: string, final: string) {
  return list.length > 1
    ? `${list.slice(0, -1).join(spacer)}${final}${list.slice(-1)}`
    : list.join('');
}
